import PaymentAddressDetail from './PaymentAddressDetail';
import {KTSVG} from '../../../../_metronic/helpers';
import {useQuery} from 'react-query';
import {PaymentAddress} from '../../../interfaces/payment-address';
import {getPaymentAddress} from '../api';
import PaymentAddressEditButton from './PaymentAddressEditButton';
import {useIntl} from 'react-intl';
import CardComponent from '../../../common/components/CardComponent';
import SelectEntity from '../payment-mode/SelectEntity';
import {useEntities} from '../../../modules/auth/authorization/PermissionProvider';
import {useState} from 'react';
import {Entity} from '../../../modules/auth/authorization/api';
import {useGetMe} from "../../../hooks/useGetMe";

const PaymentAddressCard = (): JSX.Element => {
    const intl = useIntl();
    const customer = useGetMe();
    const entities = useEntities();


    const [currentEntity, setCurrentEntity] = useState<Entity>(entities[0]);

    const {
        isFetching,
        data: paymentAddress = {
            id: '',
            name: '',
            address: '',
            zipCode: '',
            city: '',
            country: '',
        },
        refetch,
    } = useQuery<PaymentAddress>(['get-payment-address', customer], async () =>
        getPaymentAddress(customer.id.toString())
    );

    if (paymentAddress.id === '') {
        return <div></div>;
    }

    return (
        <>
            <CardComponent
                title={intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_ADDRESS.TITLE'})}
                toolbar={
                    <PaymentAddressEditButton
                        initialPaymentAddress={paymentAddress}
                        entity={currentEntity}
                        refetch={refetch}
                    />
                }
            >
                {entities.length > 1 ? (
                    <div className="pb-5">
                        <SelectEntity
                            setFieldValue={setCurrentEntity}
                            value={currentEntity}
                            entities={entities}
                        />
                    </div>
                ) : (
                    <></>
                )}
                <div className="row align-items-center">
                    <div className="col">
                        <PaymentAddressDetail
                            isFetching={isFetching}
                            paymentAddress={paymentAddress}
                        />
                    </div>
                    <div className="col">
                        <KTSVG
                            path="/media/icons/duotune/general/gen001.svg"
                            className="svg-icon-4x svg-icon-primary float-end"
                        />
                    </div>
                </div>
            </CardComponent>
        </>
    );
};

export default PaymentAddressCard;
